<div class="pupil-avatar">
  <div class="privileges">
    <span *ngFor="let privilege of studentPrivileges">
      <img src="{{ MAIN_DOMAIN }}{{ privilege?.settings_obj.character_obj.icon_url }}" 
          alt="{{ privilege?.settings_obj.character_obj.description }}">
    </span>
  </div>
  <img *ngIf="student?.avatar" class="photo" src="{{ MAIN_DOMAIN }}{{ student?.avatar }}" alt="{{student?.name}}">
  <img *ngIf="!student?.avatar" class="photo" src="{{ MAIN_DOMAIN }}{{ student?.photo_url }}" alt="{{student?.name}}">
</div>
